import UserWomanCircleColor from './UserWomanCircleColour.svg';
import UserWomanCircleDark from './UserWomanCircleDark.svg';
import UserWomanCircleLight from './UserWomanCircleLight.svg';
export const userWomanCircle = { color: UserWomanCircleColor, dark: UserWomanCircleDark, light: UserWomanCircleLight };
//# sourceMappingURL=index.js.map